{
  "related to": "#006055",
  "profiles": "#d8d800",
  "extends": "#8b4600",
  "deprecates": "#707070",
  "collects": "#46008b",
  "recommends": "#599C0F",
  "implements": "#3f0000",
  "shares data with": "#00008b",
  "shares code with": "#008b8b",
  "profiled by": "#d8d8aa",
  "extended by": "#8b46aa",
  "deprecated by": "#d800aa",
  "collected by": "#E67E22",
  "recommended by": "#27aae1",
  "implemented by": "#253442",
  "other": "#e0643e"
}
